import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/icons/ico-ico-plus.svg';
import _imports_1 from '@/assets/icons/actions/ico-close.svg';
const _hoisted_1 = { class: "link" };
const _hoisted_2 = { class: "hw-device-field" };
import { computed, onMounted, ref, watch } from "vue";
import FormInput from "@/components/forms/FormInput.vue";
import FormSelect from "@/components/forms/FormSelect.vue";
import PaginatedFetcher from "@/helpers/paginatedFetcher";
import { client } from "@/main";
import { useI18n } from "vue-i18n";
import Switcher from "@/components/switcher.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HwDeviceField',
    props: {
        value: {
            type: Number,
            required: true
        },
        sideBox: {
            type: Boolean,
            default: false
        },
        shouldDecodePayloadInit: {
            type: Boolean,
            default: false
        },
        technology: {
            type: String,
            required: false
        },
        hasError: {
            type: Boolean,
            required: false
        }
    },
    emits: ["change", "payloadDecodeChanged"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const { t: $t } = useI18n();
        onMounted(async () => {
            await loadDevices();
            if (props.value) {
                setDevice(props.value);
            }
        });
        const isExpanded = ref(false);
        const hwDevices = ref([]);
        async function loadDevices() {
            const fetcher = new PaginatedFetcher(client.path("/hwdevices").method("get").create());
            if (!props.technology) {
                hwDevices.value = await fetcher.fetchAll();
            }
            else {
                hwDevices.value = await fetcher.fetchAll({ "technology[eq]": props.technology });
            }
        }
        watch(() => props.technology, () => {
            manufacturer.value = "";
            loadDevices();
        });
        const manufacturer = ref("");
        const model = ref("");
        const revision = ref("");
        const shouldDecodePayload = ref(props.shouldDecodePayloadInit);
        watch(() => shouldDecodePayload.value, () => {
            emits("payloadDecodeChanged", shouldDecodePayload.value);
        });
        watch(() => props.shouldDecodePayloadInit, () => {
            shouldDecodePayload.value = props.shouldDecodePayloadInit;
        }, { immediate: true });
        const manufacturers = computed(() => {
            return [...new Set(hwDevices.value.map((device) => device.manufacturer))].map((manufacturer) => ({
                title: manufacturer
            }));
        });
        const models = computed(() => {
            return [...new Set(hwDevices.value.filter((dv) => dv.manufacturer === manufacturer.value).map((dv) => dv.model))].map((model) => ({
                title: model
            }));
        });
        const revisions = computed(() => {
            return hwDevices.value
                .filter((dv) => dv.manufacturer === manufacturer.value && dv.model === model.value)
                .map((dv) => ({ title: dv.revision, value: dv.hwDeviceId }));
        });
        watch(() => manufacturer.value, () => {
            model.value = "";
            revision.value = "";
            emits("change", null);
            // If there is only one model, select it (after the computed property is updated)
            setTimeout(() => {
                if (models.value.length === 1) {
                    model.value = models.value[0].title;
                }
            }, 100);
        });
        watch(() => model.value, () => {
            revision.value = "";
            emits("change", null);
            // If there is only one revision, select it (after the computed property is updated)
            setTimeout(() => {
                if (revisions.value.length === 1) {
                    revision.value = revisions.value[0].title;
                    emits("change", revisions.value[0].value);
                }
            }, 100);
        });
        watch(() => props.value, (value) => {
            setDevice(value);
        });
        function setDevice(id) {
            const device = hwDevices.value.find((dv) => dv.hwDeviceId === id);
            if (device) {
                manufacturer.value = device.manufacturer;
                setTimeout(() => {
                    model.value = device.model;
                }, 100);
                setTimeout(() => {
                    revision.value = device.revision;
                }, 100);
            }
        }
        const displayValue = computed(() => {
            if (!manufacturer.value || !model.value || !revision.value) {
                return $t("NO_DEVICE_SELECTED");
            }
            return `${manufacturer.value} / ${model.value} / ${revision.value}`;
        });
        function handleRevisionSelected($event) {
            revision.value = $event.title;
            emits("change", $event.value);
        }
        function clear() {
            emits("change", null);
            manufacturer.value = "";
            model.value = "";
            revision.value = "";
            shouldDecodePayload.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["atom-toggle pb-1", { opened: isExpanded.value, 'side-box__row d-flex': __props.sideBox }])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["atom-toggle__toggler pointer d-flex", {
                            'align-items-end justify-content-between': !__props.sideBox,
                            'align-items-center side-box__content__label justify-content-end mr-3': __props.sideBox
                        }]),
                    onClick: _cache[0] || (_cache[0] = ($event) => (isExpanded.value = !isExpanded.value))
                }, [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref($t)("HW_DEVICE_ID")), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "atom-icon mr-0" }, [
                        _createElementVNode("img", { src: _imports_0 })
                    ], -1))
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["wrapper", { 'side-box__content__input': __props.sideBox }])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(FormInput, {
                            label: "",
                            "has-error": __props.hasError,
                            class: "atom-toggle__toggler",
                            value: displayValue.value,
                            disabled: ""
                        }, null, 8, ["has-error", "value"]),
                        _createElementVNode("img", {
                            class: "clear-icon",
                            src: _imports_1,
                            onClick: _withModifiers(clear, ["stop"])
                        })
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass(["atom-toggle__content d-flex flex-column gap-3 border-top-0 border-black border-radius -mt-1", { 'p-3': isExpanded.value, 'border-1': isExpanded.value }])
                    }, [
                        _createVNode(FormSelect, {
                            label: _unref($t)('MANUFACTURER'),
                            "item-value": "title",
                            "item-text": "title",
                            value: { title: manufacturer.value },
                            items: manufacturers.value,
                            onChange: _cache[1] || (_cache[1] = ($event) => (manufacturer.value = $event.title))
                        }, null, 8, ["label", "value", "items"]),
                        _createVNode(FormSelect, {
                            disabled: !manufacturer.value,
                            label: _unref($t)('MODEL'),
                            "item-value": "title",
                            "item-text": "title",
                            value: { title: model.value },
                            items: models.value,
                            onChange: _cache[2] || (_cache[2] = ($event) => (model.value = $event.title))
                        }, null, 8, ["disabled", "label", "value", "items"]),
                        _createVNode(FormSelect, {
                            disabled: !model.value,
                            label: _unref($t)('REVISION'),
                            "item-value": "value",
                            "item-text": "title",
                            value: revisions.value.find((rev) => rev.title === revision.value),
                            items: revisions.value,
                            onChange: handleRevisionSelected
                        }, null, 8, ["disabled", "label", "value", "items"]),
                        _createVNode(Switcher, {
                            text: "",
                            disabled: !revision.value,
                            label: _unref($t)('DECODE_PAYLOAD'),
                            value: shouldDecodePayload.value,
                            onSwitch: _cache[3] || (_cache[3] =
                                () => {
                                    shouldDecodePayload.value = !shouldDecodePayload.value;
                                })
                        }, null, 8, ["disabled", "label", "value"])
                    ], 2)
                ], 2)
            ], 2));
        };
    }
});
